import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

export const enum TOAST_TYPES {
  success = 'success',
  error = 'error',
}

export interface SnackBarData {
  action?: string;
  message: string;
  type?: TOAST_TYPES;
}

export interface ToastData {
  action?: string;
  data?: SnackBarData;
  duration?: number;
  horizontalPosition?: MatSnackBarHorizontalPosition;
  message?: string;
  verticalPosition?: MatSnackBarVerticalPosition;
}
